import { Box } from "@mui/material";
import React, { useMemo } from "react";
import { borderColors } from "../../../cssUtils/constants";

const TOKEN_RE =
  /("(?:\\.|[^"\\])*")(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?/g;

const COLORS = { key: "#2b3f8f", string: "#1f7a45", literal: "#b7791f" };

// Splits pretty-printed JSON into coloured keys, strings, and numbers/booleans.
const highlight = (text) => {
  const nodes = [];
  let last = 0;
  let match;
  TOKEN_RE.lastIndex = 0;
  while ((match = TOKEN_RE.exec(text)) !== null) {
    if (match.index > last) nodes.push(text.slice(last, match.index));
    const [token, str, colon] = match;
    if (str) {
      nodes.push(
        <Box component="span" key={match.index} sx={{ color: colon ? COLORS.key : COLORS.string }}>
          {str}
        </Box>,
      );
      if (colon) nodes.push(colon);
    } else {
      nodes.push(
        <Box component="span" key={match.index} sx={{ color: COLORS.literal }}>
          {token}
        </Box>,
      );
    }
    last = match.index + token.length;
  }
  if (last < text.length) nodes.push(text.slice(last));
  return nodes;
};

const JsonView = ({ value }) => {
  const nodes = useMemo(
    () => (value ? highlight(JSON.stringify(value, null, 2)) : null),
    [value],
  );
  return (
    <Box
      component="pre"
      sx={{
        m: 0,
        p: 1.5,
        height: 560,
        overflow: "auto",
        fontSize: 11,
        lineHeight: 1.5,
        backgroundColor: "#fff",
        border: `1px solid ${borderColors.cardBorderPrimaryGrayColor}`,
        borderRadius: "6px",
      }}
    >
      {nodes || "Generating…"}
    </Box>
  );
};

export default JsonView;
